

















































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ListBase from '@/lib/listbase';
import Util from '@/lib/util';
import VWidget from '@/components/VWidget.vue';
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'

@Component({
    components: { apexcharts: VueApexCharts, VWidget },
    watch: {
        dealers: function (val) {
            (this as any).loadData();
        },
        red: function (val) {
            (this as any).loadData();
        }
    }
})

export default class ChartOperation extends ListBase {
    period: any = parseInt(Util.abp.clock.today().substr(0, 4));
    month_from: any = 1;
    month: any = parseInt(Util.abp.clock.today().substr(5, 2));
    selectedType: number = this.types[0].id;
    selectedGroup: any = null;
    options: any = {
        chart: {
            type: 'area',
            stacked: false,
            height: 350,
            zoom: {
                type: 'x',
                enabled: true,
                autoScaleYaxis: true
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                return new Intl.NumberFormat().format(value)
            }
        },
        stroke: {
            curve: 'smooth'
        },
        title: {
            text: 'PASAJEROS Y COMERCIALES',
            align: 'left'
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.7,
                opacityTo: 0,
                stops: [20, 90, 100]
            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return val.toLocaleString();
                },
            },
        },
        xaxis: {
            type: 'text',
            categories: this.monthsRange
        },
        //tooltip: {
        //    x: {
        //        format: 'dd/MM/yy HH:mm'
        //    },
        //},
        legend: {
            position: 'top',
            horizontalAlign: 'center',
            floating: true,
            offsetY: -15
        }
    };

    get periods() {
        return this.gCommonList('years');
    }

    get months() {
        let list = this.gCommonList('months');
        list.forEach(m => {
            m['field'] = 'month_' + m.id;
        });
        return list;
    }

    get types() {
        return [{ id: null, name: 'Todos' }, ...Util.abp.list.getList('T_VEHICLE')];
    }

    get dealers() {
        return this.$store.state.app.dealers;
    }

    get red() {
        return this.$store.state.app.red;
    }

    get figures() {
        return this.$store.state.dashboard.figures;
    }

    get series() {
        if (this.figures[this.selectedGroup] == undefined) return [];
        return [this.figures[this.selectedGroup]];
    }

    get totals() {
        let list = [];
        this.figures.forEach(item => {
            let amount = (item.data.length > 0 && item.data[item.last_month - 1] != null ? item.data[item.last_month - 1] : 0);
            let amount_ant = (item.data.length > 1 && item.data[item.last_month - 2] != null ? item.data[item.last_month - 2] : 0);
            let increase = 0;
            if (amount > amount_ant)
                increase = (amount > 0 ? parseFloat((100 - (amount_ant * 100 / amount)).toFixed(1)) : 0);
            else
                increase = (amount_ant > 0 ? parseFloat((100 - (amount * 100 / amount_ant)).toFixed(1)) : 0) * -1;
            list.push({
                name: item.name,
                amount: amount,
                increase: increase
            });
        });
        return list;
    }

    get loading() {
        return this.$store.state.dashboard.loading;
    }

    get monthsRange() {
        let list = this.gCommonList('months');
        let months = [];
        list.forEach(item => {
            months.push(item.name.substr(0,3));
        });

        return months;
    }

    async loadData() {
        await this.$store.dispatch({
            type: 'dashboard/getDashFigures',
            data: {
                year: this.period,
                type: this.selectedType,
                dealer: this.dealers,
                red: this.red
            }
        });          
    }

    mounted() { 
        this.loadData();
    }
}
